<template>
  <v-dialog v-model="show" max-width="500" scrollable @click:outside="close">
    <v-card height="400">
      <v-card-title class="headline">Assign New Sites</v-card-title>
      <v-card-text class="mt-5">
        <v-autocomplete
          flat
          solo
          single-line
          hide-details
          attach
          class="mb-3"
          placeholder="Search sites"
          :items="sites"
          item-value="site_id"
          item-text="name"
          return-object
          :append-icon="icons.search"
          :search-input.sync="search"
          @change="onSelectSite"
        ></v-autocomplete>
        <v-list-item
          v-for="(site, index) in selectedSites"
          :key="index"
          class="px-0"
        >
          <v-list-item-content class="py-0">
            <v-list-item-title v-text="site.name"></v-list-item-title>
            <v-list-item-subtitle v-text="site.address"></v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click="onRemoveSite(index)">
              <v-icon color="red">{{ icons.delete }}</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn color="primary" text @click="onSubmit">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiMinusCircle, mdiMagnify } from '@mdi/js'
import debounce from 'lodash/debounce'
import { mapActions, mapState, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      sites: state => state.site.list
    })
  },

  data() {
    return {
      show: this.value,
      icons: {
        delete: mdiMinusCircle,
        search: mdiMagnify
      },
      search: null,
      selectedSites: []
    }
  },

  methods: {
    ...mapMutations({
      clearSites: 'site/clearSiteList'
    }),

    ...mapActions({
      assignSitesToUser: 'site/assignSitesToUser',
      getSites: 'site/getSites'
    }),

    close() {
      this.$emit('closeModal')
      this.show = false
      this.clearList()
      this.selectedSites = []
    },

    onSelectSite(site) {
      this.search = null
      this.selectedSites.push(site)
      this.selectedSites = this.selectedSites.filter(
        (v, i, a) => a.findIndex(t => t.site_id === v.site_id) === i
      )
    },

    onRemoveSite(index) {
      this.selectedSites.splice(index, 1)
    },

    clearList() {
      this.clearSites()
    },

    debounceSearch: debounce(function(v) {
      this.searchSites(v)
    }, 600),

    async searchSites(v) {
      await this.getSites({
        search: v,
        limit: 3
      })
    },

    async onSubmit() {
      await this.assignSitesToUser({
        user_id: this.$route.params.id,
        sites: this.selectedSites.map(s => {
          return { site_id: s.site_id }
        })
      }).then(() => {
        this.close()
      })
    }
  },

  watch: {
    value(val) {
      this.show = val
    },

    search(val) {
      !val || val.length < 2 ? this.clearList() : this.debounceSearch(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list-item {
  height: 15px;
}
</style>
